var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizontalWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 102,
    viewBox: "0 0 279 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12546_45622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2695 99.74C56.2695 90.46 56.2695 81.29 56.2695 72C63.8595 76.64 71.3795 81.24 79.0195 85.91C71.3895 90.55 63.8695 95.12 56.2695 99.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.76 25.42L43.88 0L0 25.36V76.11L43.88 101.43L52.66 96.36V65.95L79.01 81.14L87.79 76.07L87.76 25.42ZM52.66 55.84L43.88 50.71V91.28L8.8 71.03V60.9L17.59 65.94V55.83L8.8 50.78V40.63L35.1 55.8V45.64L8.8 30.42L22.08 22.81L57.1 43.03V33.04L30.56 17.82L43.87 10.1L79 30.43L79.01 71.03L52.66 55.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.319 25.8799V63.0799L236.369 25.8799H226.959V67.5999H179.189V54.2299H209.359V53.7699V45.8099V45.4199H179.189V34.6799H218.159V25.8799H170.149H110.539V34.6799H131.319V75.5499H140.359V34.6799H170.149V75.5499H226.959H236.009V38.2399L269.239 75.5499H278.369V25.8799H269.319Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12546_45622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278.37,
    height: 101.43,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalWhiteLogo);
export default __webpack_public_path__ + "static/media/horizontal-white-logo.d45aabb091d208cfa270cf315b46a91a.svg";
export { ForwardRef as ReactComponent };